// extracted by mini-css-extract-plugin
export default {"cta-tile":"CtaTile_cta-tile__dGeWN"};